import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const FOOPOS_URL = "https://foopos.mx";

const EmpresasRedirectPage: React.FC = () => {
  useEffect(() => {
    window.location.replace(FOOPOS_URL);
  }, []);

  return (
    <Helmet>
      <meta httpEquiv="refresh" content={`0; url=${FOOPOS_URL}`} />
    </Helmet>
  );
};

export default EmpresasRedirectPage;
